import { useState } from "react";
import { apiUrl } from "../config/supabase";



export default function ForgotPasswordModal({ onClose, onBackToLogin }) {
  const [step,     setStep]     = useState(1); // 1=إيميل, 2=كود+باسوورد
  const [email,    setEmail]    = useState("");
  const [code,     setCode]     = useState("");
  const [newPass,  setNewPass]  = useState("");
  const [confPass, setConfPass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const [done,     setDone]     = useState(false);

  // قوة كلمة المرور
  const getStrength = (p) => {
    let s = 0;
    if (p.length >= 8) s++;
    if (/[A-Z]/.test(p)) s++;
    if (/[0-9]/.test(p)) s++;
    if (/[^A-Za-z0-9]/.test(p)) s++;
    return s;
  };
  const strength = getStrength(newPass);
  const strengthColors = ["", "#e74c3c", "#e67e22", "#f1c40f", "#27ae60"];
  const strengthLabels = ["", "ضعيفة", "مقبولة", "جيدة", "قوية 💪"];

  // ── الخطوة 1: إرسال الكود ──────────────────────────
  // ✅ كله سيرفر سايد دلوقتي: السيرفر هو اللي بيولّد الـ OTP
  //    ويخزن الـ hash بتاعه ويبعت الإيميل — الـ client مبيشوفش الكود خالص.
  const handleSendCode = async () => {
    if (!email.trim()) { setError("أدخل البريد الإلكتروني"); return; }
    setLoading(true); setError("");

    try {
      const res = await fetch(apiUrl('/api/forgot-password/request'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const result = await res.json();
      if (!res.ok) {
        setError(result.message || 'فشل إرسال الإيميل، حاول مرة تانية');
      } else {
        setStep(2);
      }
    } catch {
      setError('فشل الاتصال بالسيرفر، تأكد من الاتصال وحاول مرة تانية');
    }
    setLoading(false);
  };

  // ── الخطوة 2: التحقق من الكود + تغيير الباسوورد ───
  // ✅ التحقق من الكود وتغيير الباسورد بيحصلوا على السيرفر
  //    بالـ Service Key — مش من المتصفح زي الأول.
  const handleResetPassword = async () => {
    if (code.length !== 6)   { setError("الكود لازم يكون 6 أرقام بالظبط"); return; }
    if (newPass.length < 8)  { setError("كلمة المرور لازم تكون 8 أحرف على الأقل"); return; }
    if (newPass !== confPass) { setError("كلمتا المرور غير متطابقتين"); return; }
    setLoading(true); setError("");

    try {
      const res = await fetch(apiUrl('/api/forgot-password/reset'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email:       email.trim(),
          code:        code.trim(),
          newPassword: newPass,
        }),
      });
      const result = await res.json();
      if (!res.ok) {
        setError(result.message || 'الكود غلط أو منتهي الصلاحية — اطلب كود جديد');
        setLoading(false); return;
      }

      setDone(true);
      setLoading(false);
      setTimeout(() => { onBackToLogin(); }, 2500);
    } catch {
      setError('فشل الاتصال بالسيرفر، حاول مرة تانية');
      setLoading(false);
    }
  };

  // ── RENDER ──────────────────────────────────────────
  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={S.modal} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={S.header}>
          <div style={S.iconWrap}>
            <span style={{ fontSize: "26px" }}>
              {done ? "✅" : step === 1 ? "🔑" : "📧"}
            </span>
          </div>
          <h2 style={S.title}>
            {done ? "تم بنجاح!" : step === 1 ? "نسيت كلمة المرور؟" : "أدخل الكود"}
          </h2>
          <p style={S.subtitle}>
            {done
              ? "كلمة مرورك اتغيرت، هيتم تحويلك..."
              : step === 1
              ? "هنبعتلك كود على بريدك الإلكتروني"
              : `راجع بريدك: ${email}`}
          </p>
          {!done && <button style={S.closeBtn} onClick={onClose}>✕</button>}
        </div>

        <div style={S.body}>
          {/* ── نجاح ── */}
          {done && (
            <div style={{ textAlign: "center", padding: "16px 0" }}>
              <div style={{ fontSize: "52px", marginBottom: "12px" }}>🎉</div>
              <p style={{ color: "#27ae60", fontWeight: "700", fontSize: "16px", margin: "0 0 8px" }}>
                تم تغيير كلمة المرور!
              </p>
              <p style={{ color: "#6B7280", fontSize: "13px", margin: 0 }}>
                هيتم تحويلك لصفحة الدخول خلال ثوانٍ...
              </p>
            </div>
          )}

          {/* ── الخطوة 1: الإيميل ── */}
          {!done && step === 1 && (
            <>
              <div style={S.field}>
                <label style={S.label}>البريد الإلكتروني</label>
                <div style={S.inputWrap}>
                  <span style={S.icoR}>✉️</span>
                  <input
                    type="email" dir="ltr"
                    placeholder="example@email.com"
                    value={email}
                    onChange={e => { setEmail(e.target.value); setError(""); }}
                    onKeyDown={e => e.key === "Enter" && handleSendCode()}
                    style={S.input}
                  />
                </div>
              </div>
              {error && <p style={S.error}>⚠️ {error}</p>}
              <button onClick={handleSendCode} disabled={loading}
                style={{ ...S.btn, opacity: loading ? 0.7 : 1 }}>
                {loading ? "⏳ جاري الإرسال..." : "📨 إرسال الكود"}
              </button>
            </>
          )}

          {/* ── الخطوة 2: الكود + الباسوورد ── */}
          {!done && step === 2 && (
            <>
              {/* كود التحقق */}
              <div style={S.field}>
                <label style={S.label}>كود التحقق (6 أرقام)</label>
                <input
                  type="text" dir="ltr" maxLength={6}
                  placeholder="_ _ _ _ _ _"
                  value={code}
                  onChange={e => { setCode(e.target.value.replace(/\D/g, "")); setError(""); }}
                  style={{
                    ...S.input, textAlign: "center",
                    fontSize: "26px", letterSpacing: "10px", fontWeight: "bold",
                    padding: "12px", borderColor: code.length === 6 ? "#27ae60" : "#e8e8e8"
                  }}
                />
              </div>

              {/* كلمة المرور الجديدة */}
              <div style={S.field}>
                <label style={S.label}>كلمة المرور الجديدة</label>
                <div style={S.inputWrap}>
                  <span style={S.icoR}>🔒</span>
                  <input
                    type={showPass ? "text" : "password"} dir="ltr"
                    placeholder="8 أحرف على الأقل"
                    value={newPass}
                    onChange={e => { setNewPass(e.target.value); setError(""); }}
                    style={{ ...S.input, paddingLeft: "44px" }}
                  />
                  <button style={S.eyeBtn} onClick={() => setShowPass(x => !x)}>
                    {showPass ? "🙈" : "👁️"}
                  </button>
                </div>
                {newPass.length > 0 && (
                  <div style={{ display: "flex", gap: "4px", marginTop: "6px", alignItems: "center" }}>
                    {[1,2,3,4].map(i => (
                      <div key={i} style={{
                        flex: 1, height: "4px", borderRadius: "2px",
                        background: i <= strength ? strengthColors[strength] : "#e8e8e8",
                        transition: "background 0.3s"
                      }} />
                    ))}
                    <span style={{ fontSize: "11px", fontWeight: "600", color: strengthColors[strength], whiteSpace: "nowrap", marginRight: "6px" }}>
                      {strengthLabels[strength]}
                    </span>
                  </div>
                )}
              </div>

              {/* تأكيد كلمة المرور */}
              <div style={S.field}>
                <label style={S.label}>تأكيد كلمة المرور</label>
                <div style={S.inputWrap}>
                  <span style={S.icoR}>🔑</span>
                  <input
                    type={showPass ? "text" : "password"} dir="ltr"
                    placeholder="أعد كتابة كلمة المرور"
                    value={confPass}
                    onChange={e => { setConfPass(e.target.value); setError(""); }}
                    onKeyDown={e => e.key === "Enter" && handleResetPassword()}
                    style={{
                      ...S.input, paddingLeft: "44px",
                      borderColor: confPass && confPass !== newPass ? "#e74c3c"
                        : confPass && confPass === newPass ? "#27ae60" : "#e8e8e8"
                    }}
                  />
                  {confPass && (
                    <span style={{ position: "absolute", left: "14px", fontSize: "14px" }}>
                      {confPass === newPass ? "✅" : "❌"}
                    </span>
                  )}
                </div>
              </div>

              {error && <p style={S.error}>⚠️ {error}</p>}

              <button onClick={handleResetPassword} disabled={loading}
                style={{ ...S.btn, opacity: loading ? 0.7 : 1 }}>
                {loading ? "⏳ جاري الحفظ..." : "💾 تغيير كلمة المرور"}
              </button>

              <div style={{ textAlign: "center", marginTop: "10px" }}>
                <button onClick={() => { setStep(1); setCode(""); setError(""); }} style={S.linkBtn}>
                  ← لم يصلك الكود؟ أعد الإرسال
                </button>
              </div>
            </>
          )}

          {/* رجوع لتسجيل الدخول */}
          {!done && (
            <div style={{ textAlign: "center", marginTop: "16px" }}>
              <button onClick={onBackToLogin} style={S.linkBtn}>
                ← رجوع لتسجيل الدخول
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const S = {
  overlay: {
    position: "fixed", inset: 0,
    background: "rgba(0,0,0,0.65)", backdropFilter: "blur(4px)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 1000, padding: "20px",
  },
  modal: {
    background: "#fff", borderRadius: "20px",
    width: "100%", maxWidth: "420px",
    boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
    overflow: "hidden", direction: "rtl",
    fontFamily: "'Cairo', sans-serif",
  },
  header: {
    background: "linear-gradient(135deg,#5a67d8 0%,#764ba2 100%)",
    padding: "28px 24px", textAlign: "center", position: "relative",
  },
  iconWrap: {
    width: "60px", height: "60px",
    background: "rgba(255,255,255,0.18)", borderRadius: "50%",
    display: "flex", alignItems: "center", justifyContent: "center",
    margin: "0 auto 12px", border: "2px solid rgba(255,255,255,0.25)",
  },
  title:    { color: "#fff", margin: "0 0 6px", fontSize: "20px", fontWeight: "700" },
  subtitle: { color: "rgba(255,255,255,0.82)", margin: 0, fontSize: "13px" },
  closeBtn: {
    position: "absolute", top: "14px", left: "14px",
    background: "rgba(255,255,255,0.18)", border: "none", color: "#fff",
    width: "30px", height: "30px", borderRadius: "50%", cursor: "pointer", fontSize: "13px",
  },
  body:  { padding: "24px" },
  field: { marginBottom: "16px" },
  label: { display: "block", marginBottom: "6px", fontSize: "13px", fontWeight: "600", color: "#374151" },
  inputWrap: { position: "relative", display: "flex", alignItems: "center" },
  icoR: { position: "absolute", right: "12px", fontSize: "15px", pointerEvents: "none" },
  input: {
    width: "100%", padding: "11px 40px 11px 16px",
    border: "2px solid #e8e8e8", borderRadius: "10px",
    fontSize: "14px", outline: "none", boxSizing: "border-box",
    fontFamily: "'Cairo', sans-serif", background: "#fafafa",
    transition: "border-color 0.2s",
  },
  eyeBtn: {
    position: "absolute", left: "12px",
    background: "none", border: "none", cursor: "pointer", fontSize: "15px", padding: 0,
  },
  error: {
    color: "#e74c3c", fontSize: "13px", margin: "-6px 0 12px",
    padding: "9px 12px", background: "#fdf0ed",
    borderRadius: "8px", border: "1px solid #f5c6bb",
  },
  btn: {
    width: "100%", padding: "13px",
    background: "linear-gradient(135deg,#5a67d8,#764ba2)",
    color: "#fff", border: "none", borderRadius: "10px",
    fontSize: "15px", fontWeight: "700", cursor: "pointer",
    fontFamily: "'Cairo', sans-serif",
    boxShadow: "0 4px 15px rgba(90,103,216,0.4)",
  },
  linkBtn: {
    background: "none", border: "none", color: "#5a67d8",
    cursor: "pointer", fontSize: "13px", fontWeight: "600",
    fontFamily: "'Cairo', sans-serif",
    textDecoration: "underline", textUnderlineOffset: "3px",
  },
};
